export default {  
  data: () => ({    
  }),
  computed: {  
    videos() {
      return this.$store.getters.videos;
    },
    video() {
      return this.$store.getters.video;
    }    
  },  
  methods: {
    setVideo(id) {
      const video = this.videos.find(element => {
        return element.id == id;
      });
      this.$store.commit("clearCourseModeVideoState");
      this.$store.commit("setVideo", video);
      this.$router.push("/course/video");
    }
  }, 
};
